import { useEffect, useState } from "react"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { DTOReporteShipmentsFilters } from "../../DTO/Reportes/Filters/DTOReportesShipmentsFilters"
import { DTOReportesShipments } from "../../DTO/Reportes/DTOReportesShipments"
import DTORptFacturas from "../Cliente/DTO/DTORptFacturas"
import DataTable from "react-data-table-component"
import ReportesService from "../../Services/Reportes/Reportes.Service"
import { MsgInformativo } from "../Utils/Toast/msgInformativo"
import xlsx from "json-as-xlsx"
import { FaFileExcel } from "react-icons/fa6"

export const ReporteShipments = () => {
    const [shipments, setShipments] = useState<DTOReportesShipments[]>([])
    const [inicio, setInicio] = useState(currentDate(-30))
    const [fin, setFin] = useState(currentDate(0))
    const [trafico, setTrafico] = useState('')
    const [factura, setFactura] = useState('')
    const [pedido, setPedido] = useState('')
    const [pedimento, setPedimento] = useState('')
    const [show, setShowMsg] = useState(false)
    const [header, setHeader] = useState('')
    const [msg, setMsg] = useState('')
    const [msgColor, setMsgColor] = useState('primary')
    const [columnDefs] = useState([
        {
            name: 'ID',
            width: '100px',
            selector: (row: DTOReportesShipments) => row.id,
            sortable: true,
        },
        {
            name: 'Trafico',
            width: '100px',
            selector: (row: DTOReportesShipments) => row.trafico,
            sortable: true,
        },
        {
            name: 'Remesa',
            width: '100px',
            selector: (row: DTOReportesShipments) => row.remesa,
            sortable: true,
        },
        {
            name: 'Factura',
            width: '100px',
            selector: (row: DTOReportesShipments) => row.factura,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: (row: DTOReportesShipments) => row.descripcion,
            sortable: true,
        },
        {
            name: 'Pedido',
            selector: (row: DTOReportesShipments) => row.pedido,
            sortable: true,
        },
        {
            name: 'Aduna',
            width: '100px',
            selector: (row: DTOReportesShipments) => row.aduana,
            sortable: true,
        },
        {
            name: 'Patente',
            width: '100px',
            selector: (row: DTOReportesShipments) => row.patente,
            sortable: true,
        },
        {
            name: 'Pedimento',
            selector: (row: DTOReportesShipments) => row.pedimento,
            sortable: true,
        },
        {
            name: 'Fecha Cruce',
            selector: (row: DTOReportesShipments) => row.fechaCruce,
            sortable: true,
        },
        {
            name: 'Shipment',
            width: '100px',
            selector: (row: DTOReportesShipments) => row.shipment,
            sortable: true,
        },
    ])

    useEffect(() => {
        loadReport()
    }, [])

    const loadReport = () => {
        const filters: DTOReporteShipmentsFilters = {
            inicio,
            fin,
            trafico,
            factura,
            pedido,
            pedimento
        }
        ReportesService.getReporteShipments(filters)
        .then((response) => {
            setShipments(response.data)
            showToastMessage('Informativo', 'Se encontró la siguiente información')
            return
        })
        .catch((error) => {
            showToastMessage('Error', 'Ocurrio un error al cargar la información')
            return
        })
    }

    const showToastMessage = (type: string, message: string) => {
        setHeader(type)
        setMsg(message)
        setShowMsg(true)
    }

    function currentDate(days: number): string {
        var today = new Date()
        today.setDate(today.getDate() + days)
        var dd = String(today.getDate()).padStart(2, '0')
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        return yyyy + '-' + mm + '-' + dd
    }

    function exportExcel(jsonData: DTOReportesShipments[], fileName: string): void {
        const dataOnly = jsonData.map(
          ({
            trafico,
            remesa,
            factura,
            descripcion,
            pedido,
            aduana,
            patente,
            pedimento,
            fechaCruce,
            shipment,
          }) => {
            return {
                trafico,
                remesa,
                factura,
                descripcion,
                pedido,
                aduana,
                patente,
                pedimento,
                fechaCruce,
                shipment,
            }
          }
        )
        let data = [
          {
            sheet: 'Reporte Shipments',
            columns: [
              { label: 'Trafico', value: 'trafico' },
              { label: 'Remesa', value: 'remesa' },
              { label: 'Factura', value: 'factura' },
              { label: 'Descripcion', value: 'descripcion' },
              { label: 'Pedido', value: 'pedido' },
              { label: 'Aduana', value: 'aduana' },
              { label: 'Patente', value: 'pedimento' },
              { label: 'Pedimento', value: 'pedimento' },
              { label: 'Fecha Cruce', value: 'fechaCruce' },
              { label: 'Shipment', value: 'shipment' },
            ],
            content: dataOnly,
          },
        ]
        let settings = {
          fileName,
          extraLength: 3,
          writeOptions: {},
          RTL: false,
        }
        xlsx(data, settings)
      }

      const downloadExcel = () => {
        if(shipments.length === 0){
            showToastMessage('Error', 'Sin registros para descargar')
            return
        }
        exportExcel(shipments, `ReporteShipments_${inicio}_${fin}`)
      }
  return (
    <div>
        <Card>
            <Card.Body>
                <Row>
                    <Col xs={2}>
                        <Form.Label style={{width:'100%'}}>
                            Inicio
                            <Form.Control
                            defaultValue={inicio}
                            type='date'
                            name='Inicio'
                            placeholder='Inicio'
                            title='Inicio'
                            alt='Inicio'
                            data-date-format='YYYY-mm-dd'
                            onChange={(e) => setInicio(e.target.value)}
                            />
                        </Form.Label>    
                    </Col>
                    <Col xs={2}>
                        <Form.Label style={{width:'100%'}}>
                            Fin
                            <Form.Control
                            defaultValue={fin}
                            type='date'
                            name='Fin'
                            placeholder='Fin'
                            title='Fin'
                            alt='Fin'
                            onChange={(e) => setFin(e.target.value)}
                            />
                        </Form.Label>    
                    </Col>
                    <Col xs={2}>
                        <Form.Label style={{width:'100%'}}>
                            Trafico
                            <Form.Control
                            value={trafico}
                            type='text'
                            name='Trafico'
                            placeholder='Trafico'
                            title='Trafico'
                            alt='Trafico'
                            onChange={(e) => setTrafico(e.target.value)}
                            />
                        </Form.Label>
                    </Col>
                    <Col xs={2}>
                        <Form.Label style={{width:'100%'}}>
                            Factura
                            <Form.Control
                            value={factura}
                            type='text'
                            name='Factura'
                            placeholder='Factura'
                            title='Factura'
                            alt='Factura'
                            onChange={(e) => setFactura(e.target.value)}
                            />
                        </Form.Label>
                    </Col>
                    <Col xs={2}>
                        <Form.Label style={{width:'100%'}}>
                            Pedido
                            <Form.Control
                            value={pedido}
                            type='text'
                            name='Pedido'
                            placeholder='Pedido'
                            title='Pedido'
                            alt='Pedido'
                            onChange={(e) => setPedido(e.target.value)}
                            />
                        </Form.Label>
                    </Col>
                    <Col xs={2}>
                        <Form.Label style={{width:'100%'}}>
                            Pedimento
                            <Form.Control
                            value={pedimento}
                            type='text'
                            name='Pedimento'
                            placeholder='Pedimento'
                            title='Pedimento'
                            alt='Pedimento'
                            onChange={(e) => setPedimento(e.target.value)}
                            />
                        </Form.Label>
                    </Col>
                </Row>
                <Row className="justify-content-end">
                    <Col xs={2} style={{textAlign:'right'}}>
                        <Button variant='success' onClick={() => {downloadExcel()}} style={{marginRight:'10px'}}> <FaFileExcel/>&nbsp;Excel</Button>
                        <Button variant='success' onClick={loadReport}>Buscar</Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        <div style={{ paddingTop: '10px' }}>
                <Col xs={12}>
                  <DataTable
                    noHeader
                    defaultSortFieldId={'ID'}
                    defaultSortAsc={true}
                    pagination
                    paginationPerPage={15}
                    striped={true}
                    dense={true}
                    highlightOnHover
                    columns={columnDefs}
                    data={shipments}
                />
            </Col>
        </div>
        <MsgInformativo
                show={show}
                msg={msg}
                header={header}
                time={2000}
                msgColor={msgColor}
                closeToast={() => {
                  setShowMsg(false)
                }}
              />
    </div>
  )
}
